$(document).ready(function(){
	product_lot_methods();
});

window.product_lot_methods = function(){
	enable_disable_item_button();
	initial_selectbox_background_color_set_operation();
	$('.step1-form select').on('change', function() {
		count_agent_by_product_lots();
		set_product_lot_description($(this));
		selectbox_background_color_change_operation($(this));
	});
	show_loading_on_submit_or_back_button_click_on_modal();

	$(".product-lot__button__back").on("click", function() {
		$(".step1-form").attr("data-remote", true);
	});

	$(".product-lot__button__submit").on("click", function() {
		$(".step1-form").removeAttr("data-remote");
		$(".step1-form").removeData("remote");
	});
}

window.set_product_lot_description = function(element){
	const url = "/form/step1/set_product_lot_description";
	$.ajax({
		url,
		type: 'GET',
		data: {
			select_element_id: element.attr('id'),
			product_lot_id: element.val()
		}
	});
}

window.count_agent_by_product_lots = function(){
	const url = "/form/step1/company_count_by_product_lots";
	var item_ids = get_item_ids();
	$.ajax({
		url,
		type: 'GET',
		data: {
			customer_type: $("input[name='contact_forms_step1[customer_type]']").val(),
			product_lot_ids: $('select').map(function(){ return $(this).val(); }).get().filter(item => item),
			item_length: $('select').length,
			item_ids: item_ids
		}
	});
}

window.enable_disable_item_button = function(){
	$('.product-lot__button__submit').attr("disabled", true);
	$('.product-lot__button__submit').removeClass("btn-primary");
	$('.product-lot__button__submit').text("ロットを選択してください");
	if($('select').map(function(){ return $(this).val(); }).get().filter(item => item).length > 0) count_agent_by_product_lots();
}

window.get_item_ids = function(){
	var item_ids = $('input[name="contact_forms_step1[item][]"]').map(function(){ return $(this).val(); }).get();
	var blank_item_field_index = item_ids.indexOf("0");
	if(blank_item_field_index !== -1) item_ids.splice(blank_item_field_index, 1);
	return item_ids;
}